import React from 'react';
import IMGLogo from 'ASSETS/avenue-logo-white.png';
import './AuthLayout.less';

const AuthHeader = () => (
  <div className="auth-header">
    <img alt="Avenue" src={IMGLogo} width="120" />
  </div>
);

export default AuthHeader;



// WEBPACK FOOTER //
// ./src/components/Layout/Auth/AuthHeader.js